import axios, { AxiosResponse } from 'axios';

export const getTeams = (): Promise<AxiosResponse> => axios.get(`/teams`);

export const addUserToTeam = (teamId: string): Promise<AxiosResponse> =>
	axios.post(`/teams/add`, { teamId });
